import { CMSApiBase, createCmsUrl } from './base';
import { request } from '@/api/base';
import { snakify } from '@/helpers/common';

export interface AvatarD {
  avatarId: number;
}

export type Avatar = AvatarD & CMSApiBase;

export const createUserAvatar = (summary: AvatarD) =>
  request<Avatar>({
    method: 'POST',
    url: `/internal/cms/avatars`,
    data: snakify({ data: summary }),
  });

export const updateUserAvatar = async (fieldId: number, summary: AvatarD) =>
  request<Avatar>({
    method: 'PUT',
    url: `/internal/cms/avatars/${fieldId}`,
    data: snakify({ data: summary }),
  });

export const deleteAvatarByUserId = async (fieldId: number) =>
  request<Avatar>({
    method: 'DELETE',
    url: `/internal/cms/avatars/${fieldId}`,
  });
